import { buildDefaultHelpCenterPayload } from '@content/helpCenterDefaults'
import type { HelpCenterData } from '@store/api/helpApi'

/** Offline / API-error fallback — same payload shape as GET /api/v1/help defaults */
export const HELP_CENTER_FALLBACK: HelpCenterData = buildDefaultHelpCenterPayload()
